<template>
  <modal-box
    v-if="show_modal"
    v-bind:footer="false"
    overflow_body
    fill_height
    v-on:close="onclose">
    <template v-slot:modal-header>
      <h1 class="text-2xl font-bold leading-none text-core-900 lg:text-3xl">
        Appréciations des participants pour la formation
      </h1>
    </template>

    <template v-slot:modal-body>
      <div
        v-if="loading"
        class="h-full w-full">
        <spinner
          sizes="w-20 h-20"
          thickness="border-8" />
      </div>

      <div
        v-else
        class="flex w-full flex-wrap space-x-4 px-8 py-4 md:space-x-0 md:space-y-4">
        <h1 class="flex w-full text-lg font-bold leading-none text-core-900">
          Référence&nbsp;:&nbsp;<span class="font-normal">{{
            formation.reference
          }}</span>
        </h1>
        <h1 class="flex w-full text-lg font-bold leading-none text-core-900">
          Titre de la formation&nbsp;:&nbsp;<span class="font-normal">{{
            formation.titre
          }}</span>
        </h1>
        <div class="flex w-full flex-wrap">
          <stat-card
            size="w-1/3"
            label="Nombre de sessions animées"
            v-bind:value="detail.nbSessions" />
          <stat-card
            size="w-1/3"
            label="Nombre de participants présents"
            v-bind:value="detail.nbParticipantsPresents" />
          <stat-card
            size="w-1/3"
            label="Nombre d'appréciations fournies par les participants"
            v-bind:value="detail.nbAppreciations" />
        </div>
        <template v-if="detail && detail.reponses && detail.reponses.length">
          <div class="flex w-full flex-wrap">
            <ag-grid-wrapper
              v-bind:no_filters="true"
              v-bind:column_defs="[
                {
                  headerName: 'Note globale (%)',
                  field: 'noteGlobale',
                  cellRenderer: 'textCenterCellRenderer'
                },
                {
                  headerName: 'Maîtrise du sujet (% TB)',
                  field: 'maitriseSujet',
                  cellRenderer: 'textCenterCellRenderer'
                },
                ...(detail.technique !== undefined
                  ? [
                      {
                        headerName: 'Technique (% TB)',
                        field: 'technique',
                        cellRenderer: 'textCenterCellRenderer'
                      }
                    ]
                  : []),
                ...(detail.explicationReponsesQuestions !== undefined
                  ? [
                      {
                        headerName: 'Explication et réponses (% TP)',
                        field: 'explicationReponsesQuestions',
                        cellRenderer: 'textCenterCellRenderer'
                      }
                    ]
                  : []),
                ...(detail.explication !== undefined && detail.webinaire
                  ? [
                      {
                        headerName: 'Explications',
                        field: 'explication',
                        cellRenderer: 'textCenterCellRenderer'
                      }
                    ]
                  : []),
                ...(detail.reponsesQuestions !== undefined && detail.webinaire
                  ? [
                      {
                        headerName: 'Réponses',
                        field: 'reponsesQuestions',
                        cellRenderer: 'textCenterCellRenderer'
                      }
                    ]
                  : []),
                {
                  headerName: 'Apport expérience (% TB)',
                  field: 'apportExperience',
                  cellRenderer: 'textCenterCellRenderer'
                },
                {
                  headerName: 'Respect du Prog. (% Oui)',
                  field: 'respectProg',
                  cellRenderer: 'textCenterCellRenderer'
                }
              ]"
              v-bind:initial_data="[{ ...detail }]" />
            <div
              class="mt-1 flex w-full justify-end text-sm italic text-core-500">
              TB = Très bien, TP = Très pertinentes
            </div>
          </div>
          <div class="flex w-full flex-wrap">
            <stat-card
              size="w-1/3"
              label="Classement"
              v-bind:value="detail.classement" />
            <div class="flex w-full flex-wrap p-4 lg:w-2/3">
              <div class="flex w-full lg:w-1/3">
                <stat-chart-wrapper
                  title="Votre note globale"
                  v-bind:value="detail.noteGlobale" />
              </div>
              <div class="flex w-full lg:w-1/3">
                <stat-chart-wrapper
                  title="Note moyenne des animateurs"
                  v-bind:value="detail.noteMoyenne" />
              </div>
              <div class="flex w-full lg:w-1/3">
                <stat-chart-wrapper
                  title="Meilleure note animateur"
                  v-bind:value="detail.noteMeilleure" />
              </div>
            </div>
          </div>
          <h1
            class="flex w-full text-3xl font-bold leading-none text-jinius-green">
            Graphiques des appréciations des participants
          </h1>
          <div class="flex w-full">
            <surveyjs-analytics-wrapper
              v-if="detail && detail.surveyText"
              v-bind:json="detail.surveyText"
              v-bind:data="detail.reponses"
              ref="surveyjs-analytics-wrapper" />
          </div>
        </template></div
    ></template>
  </modal-box>
</template>
<script>
  import agGridWrapper from '@/components/utils/ag-grid/ag-grid-wrapper';
  import modalBox from '@/components/utils/modal-box.vue';
  import spinner from '@/components/utils/spinner';
  import statCard from '@/components/utils/stat-card.vue';
  import statChartWrapper from '@/components/utils/stat-chart-wrapper';
  import SurveyjsAnalyticsWrapper from '@/components/utils/surveyjs-analytics-wrapper';
  import { API } from '@/http-common';
  export default {
    components: {
      SurveyjsAnalyticsWrapper,
      modalBox,
      statCard,
      agGridWrapper,
      statChartWrapper,
      spinner
    },
    props: {
      show_modal: Boolean,
      formation: Object,
      onclose: Function
    },
    data: () => ({
      loading: false,
      detail: null
    }),
    async created() {
      await this.fetchFormation();
    },
    methods: {
      async fetchFormation() {
        this.loading = true;
        if (this.formation) {
          const response = await API.get(
            `formateur/satisfaction/formation/${this.formation.reference}`,
            this.$header_skip_redirection
          );

          this.detail = response.data;
        }

        this.loading = false;
      },
      close() {
        this.detail = null;
        this.onclose();
      }
    }
  };
</script>
<style lang="scss" scoped></style>
